import React from 'react';
import './styles.less';

const CompanyAccreditedView = () => {
	return (
		<div className="company-accredited">
			<div className="company-accredited__overlay" />
			<div className="company-accredited__content">
				<div>
					<h2 className="company-accredited__title company-accredited__title_secondary">Спасибо</h2>
					<h2 className="company-accredited__title company-accredited__title_primary">за регистрацию</h2>
				</div>
				<p className="company-accredited__text">
					Информация находится на проверке. По завершению Вы получите доступ ко всей платформе. <br />
					Для подробной информации обратитесь по номеру телефона <br />
					<b>+7 495 136 22 00</b> или почте <b>Hello@mak-logic.ru</b>
				</p>
			</div>
		</div>
	);
};

export { CompanyAccreditedView };
